export default __webpack_public_path__ + "static/media/elephant_HAPPY.32db2002.png";